import { render, staticRenderFns } from "./GlassRenders.vue?vue&type=template&id=3bfd2efe&scoped=true"
import script from "./GlassRenders.vue?vue&type=script&lang=js"
export * from "./GlassRenders.vue?vue&type=script&lang=js"
import style0 from "./GlassRenders.vue?vue&type=style&index=0&id=3bfd2efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfd2efe",
  null
  
)

export default component.exports